import { render, staticRenderFns } from "./reviewVideo.vue?vue&type=template&id=4886f007&scoped=true&"
import script from "./reviewVideo.vue?vue&type=script&lang=js&"
export * from "./reviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./reviewVideo.vue?vue&type=style&index=0&id=4886f007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886f007",
  null
  
)

export default component.exports